app.value('serverMessage', {
    "nodata" : "サーバからの応答がありませんでした",
    "timeout" : "サーバへの要求がタイムアウトしました"
})
